import {GIMMICKS_BOARD_UID} from "../../constants";

/**
 * Whether a board uid (ShortId) is the Gimmicks board (feature plan 0071) — the one Linkboard the Gimmicks page
 * shows and the Linkboard list and start-page targets leave out. The uid itself lives with the other fixed
 * uids in `constants.ts`.
 */
export function isGimmicksBoard(uid: string | null | undefined): boolean {
    return uid === GIMMICKS_BOARD_UID;
}
